import { getMeeting } from "../../api/meeting/meeting";
import { MeetingHeaderEdit } from "./MeetingEdit";
import { MeetingProvider } from "../../context/meetingContext";
import { QueryLoader } from "../Loader";
import { StyledUnit } from "../../styles/StyledUnit";
import { useQuery } from "react-query";
import MeetingBody from "./MeetingBody";
import MeetingFooter from "./MeetingFooter";
import MeetingHeader from "./MeetingHeader";
import PropTypes from "prop-types";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const emptyData = {
	isLoading: false,
	isError: false,
	error: false,
	data: {},
	refetch: () => {},
};

export default function Meeting({ id, newMeeting, isEditMode, setIsEditMode }) {
	const { axiosPrivate } = useAxiosPrivate();

	const { isLoading, isError, error, data, refetch } = newMeeting
		? emptyData
		: useQuery(["meeting-id", id], () => getMeeting(axiosPrivate, id));
	if (isLoading) {
		return <QueryLoader />;
	}
	if (isError) {
		return <div>{error}</div>;
	}

	return (
		<MeetingProvider value={data}>
			<StyledUnit>
				{newMeeting || isEditMode ? (
					<MeetingHeaderEdit edit={isEditMode} disableEditingMode={() => setIsEditMode(false)} newMeeting={newMeeting} refetch={refetch} />
				) : (
					<MeetingHeader id={id} onClick={() => setIsEditMode(true)} />
				)}

				<MeetingBody edit={newMeeting ? true : false} newMeeting={newMeeting} id={id} refetch={refetch}></MeetingBody>
				{!newMeeting ? <MeetingFooter /> : null}
			</StyledUnit>
		</MeetingProvider>
	);
}

Meeting.propTypes = {
	id: PropTypes.string,
	isEditMode: PropTypes.bool,
	setIsEditMode: PropTypes.func,
	newMeeting: PropTypes.bool,
};

Meeting.defaultProps = {
	newMeeting: false,
};
